<div
    class="py-3"
    [formGroup]="form()">
    <div class="mb-4">
        <text-input
            [formGroup]="form()"
            id="name"
            required="true"
            focus="true"
            [maxLength]="128"
            label="Room Name" />

        <name-validation-errors
            [formGroup]="form()"
            id="name"
            label="Room Name" />
    </div>

        
    <div class="mb-4">
        <text-input
            [formGroup]="form()"
            id="code"
            required="true"
            focus="true"
            [maxLength]="8"
            label="Room Code" />

        <name-validation-errors
            [formGroup]="form()"
            id="code"
            label="Room Code" />
    </div>

        
    <div class="mb-4">
        <text-input
            [formGroup]="form()"
            id="subCode"
            focus="true"
            [maxLength]="8"
            label="Room Sub Code" />
    </div>


    <div class="mb-4">
        <type-selection-list
            [types]="types()"
            [formGroup]="form()"
            required="true"
            id="type" />
    </div>

    <div class="mb-4">
        <number-input
            [formGroup]="form()"
            id="nsf"
            required="true"
            focus="true"
            label="Net Square Footage" />

        <basic-validation-errors
            [formGroup]="form()"
            id="nsf"
            label="Net Square Footage" />
    </div>


    <div class="mb-4">
        <program-selection-list
            [programs]="programs()"
            [formGroup]="form()"
            required="true"
            id="program" />
    </div>


    <div class="mb-4">
        <project-selection-list
            [projects]="projects()"
            [formGroup]="form()"
            required="true"
            id="project" />
    </div>
</div>
